module.exports = __webpack_public_path__ + "img/advantages4.58bda9a1.jpg";